import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { orderMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import { DetailItem } from '@pages/result/components'

import './index.scss'

interface IProps {
}

const Result: FC<IProps> = () => {
  const viewOrder = orderMobx.viewOrder
  const refundInfo = orderMobx.order.ordersRefundList?.[orderMobx.order.ordersRefundList?.length - 1]
  const { toPrice } = format
  return (
    <div className='refund-discount'>
      <div className='solid'></div>
      <div className='discount-content'>
        {
          !!viewOrder.discountIntegralMoneyPrice && (
            <DetailItem
              title={i18n.t('result.integralMoney')}
              content={toPrice(-orderMobx.viewOrder.discountIntegralMoneyPrice)}
            />
          )
        }
        {
          (!!viewOrder.boxPrice) && (
            <DetailItem
              title={i18n.t('result.boxPrice')}
              content={toPrice(viewOrder.boxPrice || 0)}
            />
          )
        }
        {
          (viewOrder.eatType === 'delivery' || !!viewOrder.expressPrice) && (
            <DetailItem
              title={i18n.t('result.expressPrice')}
              content={toPrice(viewOrder.expressPrice || 0)}
            />
          )
        }
        <DetailItem
          title={i18n.t('refund.discount')}
          content={toPrice(-viewOrder.totalDiscountPrice || 0)}
        />
        {
          viewOrder.discountFloorPrice > 0 && (
            <DetailItem
              title={i18n.t('result.floor')}
              content={toPrice(-viewOrder.discountFloorPrice || 0)}
            />
          )
        }
        {
          viewOrder.serviceCharge > 0 && (
            <DetailItem
              title={viewOrder.serviceChargeGratuityName}
              content={toPrice(viewOrder.serviceCharge || 0)}
            />
          )
        }
        {
          bo === 'us' && viewOrder.tax === 0 && !viewOrder.taxDetail.length && (
            <DetailItem
              title={i18n.t('result.tax')}
              content={toPrice(viewOrder.tax || 0)}
            />
          )
        }
        {
          (bo === 'us' && viewOrder.tax > 0) && viewOrder.taxDetail.map((taxItem, index) => {
            return (
              <DetailItem
                key={index}
                title={`${taxItem.taxCategoryId === -1 ? i18n.t('cart.tax') : taxItem.name || i18n.t('cart.tax')}(${!taxItem.isTaxFree ? taxItem.rate + '%' : 'exempt'})`}
                content={toPrice(taxItem.amount)}
              />
            )
          })
        }
        {
          viewOrder.showTax > 0 && bo === 'us' && (
            <DetailItem
              title={i18n.t('cart.haveTax')}
              content={toPrice(viewOrder.showTax)}
            />
          )
        }
        {
          viewOrder.tip > 0 && (
            <DetailItem
              title={i18n.t('result.tip')}
              content={toPrice(viewOrder.tip)}
            />
          )
        }
        <div className='solid'></div>
        <DetailItem
          title={i18n.t('refund.refundFee')}
          content={toPrice(viewOrder.totalPrice)}
        />
        {
          !!refundInfo && (
            <>
              <div className='solid'></div>
              <DetailItem
                title={i18n.t('refund.refundReasonTitle')}
                content={refundInfo.refundReason}
              />
            </>
          )
        }
      </div>
    </div>
  )
}

export default observer(Result)
